module.exports = __webpack_public_path__ + "static/media/man-with-pink-shirt.e7dfa685.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/man-with-pink-shirt.png
// module id = 143
// module chunks = 0